
import React, { PureComponent } from 'react'
import { Button, Modal, Col, FormGroup } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputText from '../commons/form/InputText'
import { handleKeyDown } from '../../util/utils'

class DirectionOUModal extends PureComponent {
  submitDirectionUO (values) {
    this.props.actions.saveDirectionUOModal(values, this.props.directionUOId)
  }

  render () {
    const { t, showDirectionUOModal, handleSubmit } = this.props
    const tKey = 'MASTERS.DIRECTION_OU_MASTERS.'
    return (
      <Modal id="irectionOUModal" show={showDirectionUOModal} onHide={this.props.actions.closeDirectionUOModal} className="_nf" backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}DIRECTION_OU_TITLE`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={ handleSubmit((values) => this.submitDirectionUO(values))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <FormGroup>
              <div className="search-form">
                <Field
                  component={InputText}
                  colWidth={60} // 25, 33, 50, 75, 100 default=25
                  name="description"
                  controlLabel={t('MASTERS.DESCRIPTION')}
                  placeholder={t('MASTERS.DESCRIPTION')}
                />
                <Field
                  component={InputText}
                  colWidth={40} // 25, 33, 50, 75, 100 default=25
                  name="country"
                  controlLabel={t(`${tKey}COUNTRY`)}
                  placeholder={t(`${tKey}COUNTRY`)}
                />
                <Field
                  component={InputText}
                  colWidth={60} // 25, 33, 50, 75, 100 default=25
                  name="address"
                  controlLabel={t(`${tKey}ADDRESS`)}
                  placeholder={t(`${tKey}ADDRESS`)}
                />
                <Field
                  component={InputText}
                  colWidth={40} // 25, 33, 50, 75, 100 default=25
                  name="cp"
                  controlLabel={t(`${tKey}CP`)}
                  placeholder={t(`${tKey}CP`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="city"
                  controlLabel={t(`${tKey}CITY`)}
                  placeholder={t(`${tKey}CITY`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="state"
                  controlLabel={t(`${tKey}STATE`)}
                  placeholder={t(`${tKey}STATE`)}
                />
                <Field
                  component={InputText}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="phone"
                  controlLabel={t(`${tKey}PHONE`)}
                  placeholder={t(`${tKey}PHONE`)}
                />

              </div>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R" >
              <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  if (values) {
    const tKey = 'MASTERS.DIRECTION_OU_MASTERS.VALIDATION.'
    if (!values.description) {
      errors.description = props.t(`${tKey}DESCRIPTION`)
    }
    if (!values.country) {
      errors.country = props.t(`${tKey}COUNTRY`)
    }
  }

  return errors
}

export default reduxForm({
  form: 'editDirectionUO',
  validate
})(DirectionOUModal)
